// extracted by mini-css-extract-plugin
export var backgroundImage = "SeasonalPromo-module--background-image--xiHgw";
export var button = "SeasonalPromo-module--button--WwxJp";
export var debug = "SeasonalPromo-module--debug--cN8pn";
export var innerText = "SeasonalPromo-module--inner-text--fjlMB";
export var newElement = "SeasonalPromo-module--new-element--XqlRw";
export var wrapper = "SeasonalPromo-module--wrapper---NDGD";